// extracted by mini-css-extract-plugin
export default {"field_column":"Grid_field_column__Oxy91"};